window.fwk = {
	common: {},
	controllers: {}
};
